/*
 * Smooth-scroll easing (JSD Space).
 * Adds gentle inertia to wheel scrolling and, because the animated target is
 * clamped to the page bounds, the page eases to a "slow stop" as it reaches the
 * very top or bottom (the effect requested).
 *
 * Deliberately conservative so it can't hurt usability:
 *   - desktop pointers only (never touch — touch has native momentum)
 *   - disabled for prefers-reduced-motion
 *   - ignores zoom (ctrl+wheel) and horizontal wheels
 *   - never hijacks a scroll that belongs to an inner scrollable element
 *     (drawer, dropdown, modal, <select>, etc.) or when a scroll-locked overlay
 *     is open, so those keep working natively
 *   - falls back to native scroll for keyboard / scrollbar / anchor jumps
 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(pointer: fine)');
  if (reduce.matches || !finePointer.matches) return;

  var target = window.scrollY;
  var current = window.scrollY;
  var running = false;
  var EASE = 0.14; // responsive but smooth; higher = snappier
  var EDGE_EASE = 0.28; // reach the top/bottom stop sooner, with less trailing glide

  function maxScroll() {
    return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  }
  function clamp(v) {
    return Math.max(0, Math.min(v, maxScroll()));
  }

  function loop() {
    var diff = target - current;
    var edgeTarget = target <= 0 || target >= maxScroll();
    var ease = edgeTarget ? EDGE_EASE : EASE;
    var settleDistance = edgeTarget ? 0.8 : 0.4;

    if (Math.abs(diff) < settleDistance) {
      current = target;
      window.scrollTo(0, current);
      running = false;
      return;
    }
    current += diff * ease;
    window.scrollTo(0, current);
    requestAnimationFrame(loop);
  }

  // Walk up from the wheel target: if an ancestor can actually scroll in the
  // wheel's direction, let the browser handle it natively (don't hijack).
  function scrollableAncestor(node, deltaY) {
    while (node && node !== document.body && node.nodeType === 1) {
      var style = window.getComputedStyle(node);
      var oy = style.overflowY;
      if ((oy === 'auto' || oy === 'scroll') && node.scrollHeight > node.clientHeight + 1) {
        var atTop = node.scrollTop <= 0;
        var atBottom = node.scrollTop + node.clientHeight >= node.scrollHeight - 1;
        if (!((deltaY < 0 && atTop) || (deltaY > 0 && atBottom))) return true;
      }
      node = node.parentNode;
    }
    return false;
  }

  function overlayOpen() {
    var c = document.body.classList;
    return (
      c.contains('overflow-hidden') ||
      c.contains('overflow-hidden-mobile') ||
      c.contains('overflow-hidden-tablet') ||
      c.contains('overflow-hidden-desktop')
    );
  }

  function onWheel(e) {
    if (e.ctrlKey || e.defaultPrevented) return; // pinch-zoom / already handled
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return; // horizontal intent
    if (overlayOpen()) return;
    if (scrollableAncestor(e.target, e.deltaY)) return;

    e.preventDefault();
    if (!running) {
      current = window.scrollY;
      target = current;
    }
    target = clamp(target + e.deltaY);
    if (!running) {
      running = true;
      requestAnimationFrame(loop);
    }
  }

  window.addEventListener('wheel', onWheel, { passive: false });

  // Keep in sync when the page is scrolled by other means (keyboard, scrollbar,
  // programmatic jumps) so the next wheel starts from the real position.
  window.addEventListener(
    'scroll',
    function () {
      if (!running) {
        current = target = window.scrollY;
      }
    },
    { passive: true }
  );

  // If the user switches to reduced motion at runtime, stop interfering.
  reduce.addEventListener('change', function (ev) {
    if (ev.matches) window.removeEventListener('wheel', onWheel, { passive: false });
  });
})();
